// R9: default silent autoplay, including reduced-motion / save-data preferences.
// Browser/OS policy still wins. A visitor's explicit pause also remains sticky.
// Keep R5's public state API so the unchanged composition styles keep working.
const mobile=matchMedia('(max-width:700px)');
const homeNode=document.querySelector('[data-r2-cinema]'),home=homeNode?JSON.parse(homeNode.textContent):null;
const records=[],byFrame=new Map();let scheduled=0;
const labels=window.__TOS282__.video;
function source(frame){
 const explicit=mobile.matches?frame.dataset.filmMobile:frame.dataset.filmDesktop;
 if(explicit)return explicit;
 const pair=(home||window.__R5_ROOM_FILMS__||{})[frame.dataset.scene];
 return pair?.[mobile.matches?'mobile':'desktop']||'';
}
function state(record,value){
 record.frame.dataset.r5State=value;record.frame.dataset.state=value;
 record.button.setAttribute('aria-label',value==='playing'?labels.pause:labels.start);
 record.button.setAttribute('aria-pressed',String(value==='playing'));
}
function stop(record){
 record.epoch++;record.pending=false;record.video.autoplay=false;record.video.pause();
 state(record,record.video.readyState>=2&&record.video.currentTime>0?'paused':'poster');
}
async function play(record,manual=false){
 if(document.hidden||!record.active||record.userPaused)return;
 if(record.pending||(!record.video.paused&&record.frame.dataset.r5State==='playing'))return;
 if(!manual&&(record.policyBlocked||record.failures>=2))return;
 const url=source(record.frame);if(!url)return;
 const video=record.video,epoch=++record.epoch;record.pending=true;
 video.muted=true;video.defaultMuted=true;video.playsInline=true;video.loop=true;video.autoplay=true;
 if(record.url!==url||video.error){video.pause();record.url=url;video.src=url;video.load();}
 try{
  await video.play();
  if(epoch!==record.epoch)return;
  record.failures=0;record.policyBlocked=false;record.lastError='';record.pending=false;state(record,'playing');
 }catch(error){
  if(epoch!==record.epoch)return;
  record.pending=false;video.autoplay=false;
  if(error.name==='AbortError')return;
  record.failures++;record.lastError=error.name;record.policyBlocked=error.name==='NotAllowedError';state(record,'blocked');
 }
}
function visibleScore(frame){
 const rect=frame.getBoundingClientRect(),style=getComputedStyle(frame);
 if(!rect.width||!rect.height||style.visibility==='hidden'||style.display==='none')return 0;
 const width=Math.max(0,Math.min(innerWidth,rect.right)-Math.max(0,rect.left));
 const height=Math.max(0,Math.min(innerHeight,rect.bottom)-Math.max(0,rect.top));
 if(height<=0||width<=0)return 0;
 return width*height;
}
function sync(){
 scheduled=0;
 for(const record of records){
  const wasActive=record.active;
  record.active=!document.hidden&&visibleScore(record.frame)>0;
  // Films meeting at a scene boundary must not freeze one another. Only visible
  // films load/play; the rest of the page doesn't decode seven offscreen movies.
  if(record.active){if(!wasActive&&!record.policyBlocked)record.failures=0;play(record);}
  else if(!record.video.paused||record.pending||record.video.autoplay)stop(record);
 }
}
function schedule(){if(!scheduled)scheduled=requestAnimationFrame(sync);}
const observer=new IntersectionObserver(schedule,{threshold:[0,.05,.2,.5,.8,1]});
function discover(){
 document.querySelectorAll('[data-motion-toggle],.cinema__cta').forEach(n=>n.remove());
 document.querySelectorAll('[data-cinema-loop]').forEach(frame=>{
  if(byFrame.has(frame)||!source(frame))return;
  const video=frame.querySelector('video');if(!video)return;
  // The video itself is decorative, but its pause surface must be reachable.
  for(let node=frame;node&&node!==document.body;node=node.parentElement)if(node.getAttribute('aria-hidden')==='true')node.removeAttribute('aria-hidden');
  video.autoplay=true;video.controls=false;video.preload='none';video.muted=true;video.defaultMuted=true;video.playsInline=true;video.loop=true;
  video.setAttribute('muted','');video.setAttribute('playsinline','');video.setAttribute('aria-hidden','true');video.setAttribute('disablepictureinpicture','');
  video.id=video.id||'r5-film-'+(records.length+1);
  const button=document.createElement('button');button.type='button';button.className='r5-film-hit';button.setAttribute('aria-controls',video.id);
  const record={frame,video,button,userPaused:false,active:false,policyBlocked:false,lastError:'',failures:0,epoch:0,pending:false,url:''};
  records.push(record);byFrame.set(frame,record);frame.append(button);state(record,'poster');
  button.addEventListener('click',()=>{
   if(!video.paused||record.pending){record.userPaused=true;stop(record);}
   else{record.userPaused=false;record.active=visibleScore(frame)>0;record.policyBlocked=false;record.failures=0;play(record,true);}
  });
  video.addEventListener('playing',()=>{
   if(!record.active||record.userPaused||document.hidden){stop(record);return;}
   record.failures=0;record.policyBlocked=false;record.lastError='';state(record,'playing');
  });
  video.addEventListener('pause',()=>{
   if(!record.pending&&frame.dataset.r5State==='playing')state(record,video.readyState>=2?'paused':'poster');
  });
  video.addEventListener('canplay',schedule);
  video.addEventListener('error',()=>{record.epoch++;record.failures=2;record.lastError='MediaError';record.pending=false;video.autoplay=false;state(record,'blocked');});
  observer.observe(frame);
 });
 schedule();
}
window.addEventListener('r5:film-sources',discover);
window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});
function recover(){
 if(document.hidden)return;
 for(const record of records)if(!record.userPaused){record.failures=0;record.policyBlocked=false;}
 schedule();
}
document.addEventListener('visibilitychange',()=>document.hidden?sync():recover());
window.addEventListener('pageshow',recover);window.addEventListener('online',recover);
window.addEventListener('pagehide',()=>{for(const record of records){record.active=false;stop(record);}});
mobile.addEventListener('change',()=>{for(const record of records){stop(record);record.url='';record.video.removeAttribute('src');record.video.load();record.failures=0;}schedule();});
// A real click / touchend / activation key is a valid recovery opportunity.
// There is no timer loop, synthetic gesture or browser-policy bypass.
function gesture(event){
 if(event.target instanceof Element&&event.target.closest('.r5-film-hit'))return;
 if(event.type==='keydown'&&!['Enter',' '].includes(event.key))return;
 for(const record of records)if(!record.userPaused&&visibleScore(record.frame)>0&&record.video.paused&&!record.pending){
  record.active=true;record.failures=0;record.policyBlocked=false;play(record,true);
 }
}
document.addEventListener('click',gesture,{passive:true});
document.addEventListener('touchend',gesture,{passive:true});
document.addEventListener('keydown',gesture);
window.__TOS_R5_VIDEO__={records,sync,discover};
discover();

document.addEventListener('shopify:section:load',discover);
